import { Symptom } from "../../model/symptom";
import { ActiveAudit } from "../activeAudit";

export interface ServiceToOffer extends ActiveAudit{
  id: number;
  name: string;
  description: string;
  symptoms: Symptom[];
  checked?: boolean;
}

export class PracticeServiceOffer implements ServiceToOffer{
  id: number;
  name: string;
  description: string;
  symptoms: Symptom[];
  checked?: boolean;
  active: boolean;
  createdDate: string;
  modifiedDate: string;
  createdBy: number;
  modifiedBy: number;
  
}